var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSession = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1398 7.14746H6.97445C4.32826 7.14746 2.18311 9.31111 2.18311 11.9801V40.976C2.18311 43.645 4.32826 45.8086 6.97445 45.8086H26.1398C28.786 45.8086 30.9311 43.645 30.9311 40.976V11.9801C30.9311 9.31111 28.786 7.14746 26.1398 7.14746Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.853 2.19092H12.2616C11.0754 2.19092 10.1138 3.22651 10.1138 4.50398V6.81704C10.1138 8.09451 11.0754 9.1301 12.2616 9.1301H20.853C22.0392 9.1301 23.0008 8.09451 23.0008 6.81704V4.50398C23.0008 3.22651 22.0392 2.19092 20.853 2.19092Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1138 21.0259H23.0008M10.1138 27.4694H23.0008M10.1138 33.9129H23.0008",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSession);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/session.ced082d31cd2773ba2f281f300fff954.svg";